import type { Dictionary } from '~/types/components/dictionary';
import { ShippingSupportCountry } from '~/types/resources';

export const translateCountryCodeToLocaleText = (input: {
  countryCode: ShippingSupportCountry;
  dictionary: Dictionary | null;
}) => {
  const { countryCode, dictionary } = input;
  if (dictionary == null) {
    return countryCode;
  }
  return dictionary.country[countryCode];
};
